module.exports = __webpack_public_path__ + "img/Multi options.3862bfc.png";